var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLenovoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 51,
    viewBox: "0 0 105 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3294_10932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7672 19.9438C43.0408 19.9438 41.0775 20.7331 39.8779 22.3131L39.8787 22.3099L39.8779 22.3107L39.8787 20.192H35.7612V34.9792H39.8779V26.5651C39.8779 25.0506 41.0686 23.441 43.273 23.441C44.9766 23.441 46.7395 24.6096 46.7395 26.5651V34.9792H50.857V25.8126C50.857 22.4116 48.3896 19.9438 44.7672 19.9438Z",
    fill: "#E60012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1205 20.1926L76.3983 30.2653L72.6761 20.1926H67.9727L74.1419 34.9751H78.6539L84.8231 20.1926H80.1205Z",
    fill: "#E60012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4694 24.6473C24.1706 23.7188 25.2874 23.1737 26.6364 23.1737C28.1201 23.1737 29.2458 24.0093 29.8278 25.2428L22.6342 28.186C22.4378 26.6756 22.8298 25.4941 23.4694 24.6473ZM31.3796 30.4328C29.6468 31.6975 28.6566 31.9993 27.0763 31.9993C25.6543 31.9993 24.5407 31.5638 23.7559 30.8002L34.282 26.4939C34.0523 24.889 33.4347 23.4554 32.4843 22.3652C31.1012 20.7812 29.0543 19.9431 26.5617 19.9431C22.0344 19.9431 18.6206 23.2369 18.6206 27.5873C18.6206 32.0505 22.0425 35.2306 27.0154 35.2306C29.8018 35.2306 32.6506 33.9283 33.9834 32.4067L31.3796 30.4328Z",
    fill: "#E60012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.228 31.2508H8.86975V15.7695H4.69629V34.9792H18.228V31.2508Z",
    fill: "#E60012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2163 23.4226C89.9169 23.4226 88.2473 25.1411 88.2473 27.5857C88.2473 29.9197 90.0159 31.7487 92.2715 31.7487C94.5716 31.7487 96.2404 29.983 96.2404 27.5857C96.2404 25.2516 94.4726 23.4226 92.2163 23.4226ZM92.2163 35.2282C87.7133 35.2282 84.1851 31.92 84.1851 27.5857C84.1851 23.3001 87.7376 19.9431 92.2715 19.9431C96.7744 19.9431 100.302 23.2513 100.302 27.5857C100.302 31.8704 96.7501 35.2282 92.2163 35.2282Z",
    fill: "#E60012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5162 23.4226C58.2168 23.4226 56.5481 25.1411 56.5481 27.5857C56.5481 29.9197 58.3159 31.7487 60.5722 31.7487C62.8716 31.7487 64.5403 29.983 64.5403 27.5857C64.5403 25.2516 62.7726 23.4226 60.5162 23.4226ZM60.5162 35.2282C56.0132 35.2282 52.4858 31.92 52.4858 27.5857C52.4858 23.3001 56.0376 19.9431 60.5722 19.9431C65.0744 19.9431 68.6026 23.2513 68.6026 27.5857C68.6026 31.8704 65.05 35.2282 60.5162 35.2282Z",
    fill: "#E60012"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3294_10932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96.5714,
    height: 20,
    fill: "white",
    transform: "translate(4.21387 15.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLenovoLogo);
export default __webpack_public_path__ + "static/media/icon-lenovo-logo.1d986c970beb932bec4933018e5c409f.svg";
export { ForwardRef as ReactComponent };